module.exports = __webpack_public_path__ + "media/components/Influencers/Layouts/Header/logo-85d3e880689524721923c885a45c6d50.png";